var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pageObjectType === 'SPORT_COMPETITOR')?_c('SingleStepTeam'):(_vm.pageObjectType === 'SPORT_COMPETITION')?_c('SingleStepCompetition'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }